import $ from 'jquery';

export default function () {
	$('.filtertron').filtertron('entries', {
		expander: '#filtertronExpander',
	});
}
